import {
  addComment,
  clearComments,
  deleteComment,
  fetchComments,
  loadMoreComments,
  updateComment,
} from '../routines/viceRoutine';
import { DEFAULT_SORT_ORDER } from '../../common/constants/ViceConstants';

const initialState = {
  commentsList: {},
  commentMetaData: {},
  addingComment: false,
  addCommentSuccess: false,

  fetchingComments: {},
  fetchingCommentsSuccess: {},

  selectedComment: null,
  deletedComment: null,
  updatingComment: false,
  updatingCommentSuccess: false,
  deletingComment: false,
  deletingCommentSuccess: false,

  repliesList: [],
  repliesListSuccess: false,
  repliesListLoading: false,
};

const viceReducer = (state = initialState, action) => {
  switch (action.type) {
    //   Fetching comments
    case fetchComments.TRIGGER: {
      const { context, contextId } = action.payload;
      return {
        ...state,
        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: true,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: false,
          },
        },
      };
    }
    case fetchComments.SUCCESS: {
      const { response, order, context, contextId } = action.payload;
      return {
        ...state,
        commentsList: {
          ...state.commentsList,
          [context]: {
            ...state.commentsList[context],
            [contextId]: response.comments || [],
          },
        },
        commentMetaData: {
          ...state.commentMetaData,
          [context]: {
            ...state.commentMetaData[context],
            [contextId]: {
              page: response.page,
              pageSize: response.pageSize,
              totalItems: response.totalItemCount,
              order: order || DEFAULT_SORT_ORDER,
            },
          },
        },
        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: false,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: true,
          },
        },
      };
    }
    case fetchComments.FAILURE: {
      const { context, contextId } = action.payload;
      return {
        ...state,

        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: false,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: false,
          },
        },
      };
    }

    //   Load More comments
    case loadMoreComments.TRIGGER: {
      const { context, contextId } = action.payload;
      return {
        ...state,
        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: true,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: false,
          },
        },
      };
    }
    case loadMoreComments.SUCCESS: {
      const { response, context, contextId } = action.payload;
      const { commentMetaData, commentsList } = state;
      const updatedCommentsList = [
        ...(commentsList?.[context]?.[contextId] || []),
        ...response.comments,
      ];
      return {
        ...state,
        commentsList: {
          ...commentsList,
          [context]: {
            ...state.commentsList[context],
            [contextId]: updatedCommentsList || [],
          },
        },
        commentMetaData: {
          ...commentMetaData,
          [context]: {
            ...commentMetaData[context],
            [contextId]: {
              ...commentMetaData?.[context]?.[contextId],
              page: response.page,
              pageSize: response.pageSize,
              totalItems: response.totalItemCount,
            },
          },
        },
        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: false,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: true,
          },
        },
      };
    }
    case loadMoreComments.FAILURE: {
      const { context, contextId } = action.payload;
      return {
        ...state,
        fetchingComments: {
          ...state.fetchingComments,
          [context]: {
            ...state.fetchingComments[context],
            [contextId]: false,
          },
        },
        fetchingCommentsSuccess: {
          ...state.fetchingCommentsSuccess,
          [context]: {
            ...state.fetchingCommentsSuccess[context],
            [contextId]: false,
          },
        },
      };
    }

    //   adding a comment
    case addComment.TRIGGER:
      return {
        ...state,
        addingComment: true,
        addCommentSuccess: false,
      };
    case addComment.SUCCESS: {
      const { response, context, contextId } = action.payload;
      const { commentsList } = state;
      const newCommentsList = { ...commentsList };
      return {
        ...state,
        commentsList: {
          ...newCommentsList,
          [context]: {
            ...newCommentsList?.[context],
            [contextId]: [
              ...(newCommentsList[context]?.[contextId] || []),
              response,
            ],
          },
        },
        addingComment: false,
        addCommentSuccess: true,
      };
    }
    case addComment.FAILURE:
      return {
        ...state,
        addingComment: false,
        addCommentSuccess: false,
      };

    //   updating a comment
    case updateComment.TRIGGER: {
      const { updatedComment, commentId, context, contextId } = action.payload;
      const { commentsList } = state;
      const newCommentsList = { ...commentsList };
      const commentIndex = newCommentsList?.[context]?.[contextId]?.findIndex(
        (comment) => comment.commentId === commentId
      );
      const selectedComment =
        newCommentsList?.[context]?.[contextId]?.[commentIndex];

      if (commentIndex !== -1) {
        const updatedCommentList = newCommentsList?.[context]?.[contextId]?.map(
          (comment, index) => {
            if (index === commentIndex) {
              return {
                ...comment,
                comment: updatedComment,
              };
            }
            return comment;
          }
        );

        return {
          ...state,
          selectedComment,
          commentsList: {
            ...newCommentsList,
            [context]: {
              ...newCommentsList?.[context],
              [contextId]: updatedCommentList,
            },
          },
          updatingComment: true,
          updatingCommentSuccess: false,
        };
      }
      return state;
    }
    case updateComment.SUCCESS: {
      const { context, contextId } = action.payload;
      const { response } = action.payload;
      const { commentId } = response;
      const { commentsList } = state;
      const newCommentsList = { ...commentsList };
      const commentIndex = newCommentsList?.[context]?.[contextId]?.findIndex(
        (comment) => comment.commentId === commentId
      );

      if (commentIndex !== -1) {
        const updatedCommentList = newCommentsList?.[context]?.[contextId]?.map(
          (comment, index) => {
            if (index === commentIndex) {
              return response;
            }
            return comment;
          }
        );

        return {
          ...state,
          commentsList: {
            ...newCommentsList,
            [context]: {
              ...newCommentsList?.[context],
              [contextId]: updatedCommentList,
            },
          },
          updatingComment: false,
          updatingCommentSuccess: true,
        };
      }

      return state;
    }
    case updateComment.FAILURE: {
      const { context, contextId } = action.payload;
      const { commentsList, selectedComment } = state;
      const newCommentsList = { ...commentsList };
      const commentIndex = commentsList?.[context]?.[contextId]?.findIndex(
        (comment) => comment.commentId === selectedComment.commentId
      );

      if (commentIndex !== -1) {
        const updatedCommentList = newCommentsList?.[context]?.[contextId]?.map(
          (comment, index) => {
            if (index === commentIndex) {
              return selectedComment;
            }
            return comment;
          }
        );

        return {
          ...state,
          commentsList: {
            ...newCommentsList,
            [context]: {
              ...newCommentsList?.[context],
              [contextId]: updatedCommentList,
            },
          },
          updatingComment: false,
          updatingCommentSuccess: true,
          selectedComment: null,
        };
      }
      return state;
    }

    //   deleting a comment
    case deleteComment.TRIGGER:
      return {
        ...state,
        deletingComment: true,
        deletingCommentSuccess: false,
      };
    case deleteComment.SUCCESS: {
      const { commentId, context, contextId } = action.payload;
      const newCommentsList = { ...state.commentsList };
      const commentIndex = newCommentsList?.[context]?.[contextId]?.findIndex(
        (comment) => comment.commentId === commentId
      );
      const deletedComment =
        newCommentsList?.[context]?.[contextId]?.[commentIndex];

      if (commentIndex !== -1) {
        const updatedCommentList = newCommentsList?.[context]?.[
          contextId
        ]?.filter((comment, index) => index !== commentIndex);

        return {
          ...state,
          commentsList: {
            ...newCommentsList,
            [context]: {
              ...newCommentsList?.[context],
              [contextId]: updatedCommentList,
            },
          },
          deletedComment,
          deletingComment: false,
          deletingCommentSuccess: true,
        };
      }
      return state;
    }
    case deleteComment.FAILURE: {
      const { context, contextId } = action.payload;
      const newCommentsList = { ...state.commentsList };

      return {
        ...state,
        commentsList: {
          ...newCommentsList,
          [context]: {
            ...newCommentsList?.[context],
            [contextId]: [
              ...(newCommentsList?.[context]?.[contextId] || []),
              state.deletedComment,
            ],
          },
        },
        deletingComment: false,
        deletingCommentSuccess: false,
      };
    }

    //   clearing comment data
    case clearComments.SUCCESS: {
      const { context, contextId } = action.payload;
      const updatedCommentsList = {
        ...state.commentsList,
        [context]: {
          ...state.commentsList?.[context],
          [contextId]: [],
        },
      };
      const updatedCommentMetaData = {
        ...state.commentMetaData,
        [context]: {
          ...state.commentMetaData?.[context],
          [contextId]: {},
        },
      };

      return {
        ...state,
        commentsList: updatedCommentsList,
        commentMetaData: updatedCommentMetaData,
      };
    }

    default:
      return state;
  }
};

export default viceReducer;
